interface BoxWithDownArrowRightProps {
  height?: number | string;
  width?: number | string;
  fillColor?: string;
}

/** Box-and-arrow action glyph used for Historic NAR row actions. */
const BoxWithDownArrowRight = ({
  height = 16,
  width = 16,
  fillColor = "#0056D6",
}: BoxWithDownArrowRightProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.364 2.5C6.364 2.36739 6.41668 2.24021 6.51045 2.14645C6.60421 2.05268 6.73139 2 6.864 2H13.5C13.8978 2 14.2794 2.15804 14.5607 2.43934C14.842 2.72064 15 3.10218 15 3.5V13.5C15 13.8978 14.842 14.2794 14.5607 14.5607C14.2794 14.842 13.8978 15 13.5 15H3.5C3.10218 15 2.72064 14.842 2.43934 14.5607C2.15804 14.2794 2 13.8978 2 13.5V6.864C2 6.73139 2.05268 6.60421 2.14645 6.51045C2.24021 6.41668 2.36739 6.364 2.5 6.364C2.63261 6.364 2.75979 6.41668 2.85355 6.51045C2.94732 6.60421 3 6.73139 3 6.864V13.5C3 13.6326 3.05268 13.7598 3.14645 13.8536C3.24021 13.9473 3.36739 14 3.5 14H13.5C13.6326 14 13.7598 13.9473 13.8536 13.8536C13.9473 13.7598 14 13.6326 14 13.5V3.5C14 3.36739 13.9473 3.24021 13.8536 3.14645C13.7598 3.05268 13.6326 3 13.5 3H6.864C6.73139 3 6.60421 2.94732 6.51045 2.85355C6.41668 2.75979 6.364 2.63261 6.364 2.5Z"
      fill={fillColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0001 10.5006C11.0001 10.6332 10.9475 10.7604 10.8537 10.8542C10.7599 10.948 10.6328 11.0006 10.5001 11.0006H5.50014C5.36754 11.0006 5.24036 10.948 5.14659 10.8542C5.05282 10.7604 5.00014 10.6332 5.00014 10.5006C5.00014 10.368 5.05282 10.2408 5.14659 10.1471C5.24036 10.0533 5.36754 10.0006 5.50014 10.0006H9.29314L1.14614 1.85463C1.09966 1.80814 1.06278 1.75295 1.03762 1.69222C1.01246 1.63148 0.999512 1.56638 0.999512 1.50063C0.999512 1.43489 1.01246 1.36979 1.03762 1.30905C1.06278 1.24831 1.09966 1.19312 1.14614 1.14663C1.19263 1.10014 1.24782 1.06327 1.30856 1.03811C1.3693 1.01295 1.4344 1 1.50014 1C1.56589 1 1.63099 1.01295 1.69173 1.03811C1.75247 1.06327 1.80766 1.10014 1.85414 1.14663L10.0001 9.29363V5.50063C10.0001 5.36802 10.0528 5.24085 10.1466 5.14708C10.2404 5.05331 10.3675 5.00063 10.5001 5.00063C10.6328 5.00063 10.7599 5.05331 10.8537 5.14708C10.9475 5.24085 11.0001 5.36802 11.0001 5.50063V10.5006Z"
      fill={fillColor}
    />
  </svg>
);

export default BoxWithDownArrowRight;
